import React, {useEffect} from 'react';
import {
    makeStyles,
    Paper,
    Typography,
    TableRow,
    TableHead,
    TableContainer,
    TableCell,
    TableBody,
    Table,
    IconButton,
    Collapse,
    Box,
    useTheme, Tooltip
} from '@material-ui/core'
import Row from './row'
import {LookupParams} from "../App";
import './table.css'
import {ExtendedLookupResponse} from "../App";

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tableCellStyles: {
        color: 'black'
    }
});


type RecordType = 'A' | 'AAAA' | 'CNAME' | 'TXT' | 'MX' | 'NS' | 'SOA' | 'SRV';

export interface QueryParams {
    nameServer: string;
    location: string;
    host: string;
    type: RecordType,
}

export interface LookupTableProps {
    lookups: Array<ExtendedLookupResponse>;
    deleteRow: any;
    appliedFilter: LookupParams | undefined;
}

interface FilterParams {
    host: RegExp | string;
    nameServer: RegExp | string;
    type: RegExp | string;
    location: RegExp | string;
}


export default function LookupTable(props: LookupTableProps) {
    const {lookups, deleteRow, appliedFilter} = props
    const classes = useRowStyles();
    const theme = useTheme()
    console.log("LOOKUPS", lookups)

    function filterResults(filterPerams: FilterParams | undefined) {
        if (!!filterPerams) {
            const {host = /.*/g, nameServer = /.*/g, type = /.*/g, location = /.*/g} = filterPerams
            return lookups.filter(obj => !!obj.host.match(host)).filter(obj => obj.nameServer.match(nameServer)).filter(obj => obj.recordtype.match(type)).filter(obj => obj.location.match(location))
        } else {
            return lookups
        }

    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                backgroundImage: `url("https://www.coderelite.com/build/static/media/BLANK_MAP_2021.svg")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%'
            }}>
            <div style={{
                display: 'flex',
                justifyContent: "space-around",
                color: `${theme.palette.secondary.main}`,
                marginTop: '40px',
                padding: '0 0 0 80px'
            }}>
                <h4>Domain</h4>
                <h4>Location</h4>
                <h4>Resolver</h4>
                <h4>Response Time</h4>
                <div></div>
            </div>
            <div style={{height: '100%', width: '100%', padding: '0 30px', overflow: 'scroll', marginBottom: '20px'}}>
                {filterResults(appliedFilter).length > 0 ? (
                        <>
                            {filterResults(appliedFilter).slice(0,1).map((row, index) => (
                                <TableContainer key={index} style={{marginBottom: '10px', transition: '3s'}}
                                                component={Paper}>
                                    <Table aria-label="collapsible table">
                                        <TableBody>
                                            <Row key={row.host} row={row} deleteRow={(row: string) => deleteRow(row)}
                                                 index={index} rowOpen={true}/>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ))}
                            {filterResults(appliedFilter).slice(1).map((row, index) => (
                                <TableContainer key={index} style={{marginBottom: '10px', transition: '3s'}}
                                                component={Paper}>
                                    <Table aria-label="collapsible table">
                                        <TableBody>
                                            <Row key={row.host} row={row} deleteRow={(row: string) => deleteRow(row)}
                                                 index={index}/>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ))}
                        </>
                    )
                    :
                    <TableContainer style={{background: `${theme.palette.secondary.main}`  ,marginBottom: '10px'}} component={Paper}>
                        <Table>
                            <TableBody>
                                <TableRow className={classes.root}>
                                    <TableCell
                                        style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <div style={{fontWeight: 'bold'}}>Please fill out the required fields. Then
                                            click &nbsp;</div>
                                        <img src="https://www.coderelite.com/build/static/media/runbutton2.svg" alt="Run Button"/>
                                        <div style={{fontWeight: 'bold'}}>&nbsp; to run the check.</div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </div>
        </div>
    )
}